export default __webpack_public_path__ + "static/media/icon_skip_arrows_mobile.40eca261.svg";